import { Badge, EyeClosedIcon, Link, Tag } from '@ds/components'

import type { TAudioDetailsProps, TAudioTagItem } from './AudioDetails.types'
import styles from './AudioDetails.module.css'

const renderTag = ({ label, href }: TAudioTagItem, index: number) =>
    href ? (
        <Link key={`${index}-${label}`} variant="ghost" href={href} className={styles.tagLink}>
            <Tag>{label}</Tag>
        </Link>
    ) : (
        <Tag key={`${index}-${label}`}>{label}</Tag>
    )

export const AudioDetails = ({
    description,
    descriptionSlot,
    descriptionEmptyLabel,
    isUnlisted,
    categoryTitle,
    categoryHref,
    noCategoryLabel,
    tags,
}: TAudioDetailsProps) => (
    <div className={styles.details}>
        <p className={styles.description}>
            {description ? (
                (descriptionSlot ?? description)
            ) : (
                <span className={styles.empty}>{descriptionEmptyLabel}</span>
            )}
        </p>
        <div className={styles.tags}>
            {isUnlisted ? <Badge variant="default" Icon={EyeClosedIcon} /> : null}
            {categoryTitle && categoryHref ? (
                <Link variant="ghost" href={categoryHref} className={styles.tagLink}>
                    <Tag>{categoryTitle}</Tag>
                </Link>
            ) : (
                <Badge variant="error">{noCategoryLabel}</Badge>
            )}
            {tags.map(renderTag)}
        </div>
    </div>
)
